/**
 * Remove computed `url` fields from image refs before PUT (DB stores fileKey only).
 */
export function stripCmsComputedUrls<T>(value: T): T {
  const clone = JSON.parse(JSON.stringify(value)) as T;
  const walk = (node: unknown): void => {
    if (!node || typeof node !== "object") return;
    if (Array.isArray(node)) {
      node.forEach(walk);
      return;
    }
    const o = node as Record<string, unknown>;
    if ("fileKey" in o && "url" in o) {
      delete o.url;
    }
    Object.values(o).forEach(walk);
  };
  walk(clone);
  return clone;
}
